module.exports = __webpack_public_path__ + "static/media/background-popup-desktop.01b6198b.png";